export default "__VITE_ASSET__V4G5aPwX__"